import Model from './model'

export default class Facility extends Model {
  constructor() {
    super()
    this.hydrate({
      gallery_id: '',
      name: '',
      file: '',
      sort: '',
      seating_capacity: '',
      minimum_hours: '',
      intro: '',
      description: '',
      week_start_time: '',
      week_slots: '',
      weekend_start_time: '',
      weekend_slots: '',
      active: true,
      featured: true,
      serves_alcohol: false,
      weekdays_available: false,
      weekends_available: false,
      base_rate: '',
      base_deposit: '',
      base_cleaning: '',
      base_cleaning_after_hours: '',
      base_security: '',
      base_security_after_hours: '',
      roles: [],
      pricing: [],
      extras: []
    })
  }

  get payload() {
    return {
      ...this,
      roles: this.roles.map(role => role.id),
    }
  }
}